import { PageViewEventLogger } from '@repo/tracking-service';
import { AuthGuard, useAuthContext } from '@repo/user-session';
import { Suspense, useEffect } from 'react';
import { useQueryLoader } from 'react-relay';

import { mySectionUserQuery } from '@/__generated__/mySectionUserQuery.graphql';
import {
  MenuBottomCardBanner,
  EventSection,
  HelpSection,
  InfoSection,
  MenuLayerTopNavigation,
  MySection,
  MySectionFallbackComponent,
  RefundSection
} from '@/components/menu';
import s from '@/components/my/common/layout.module.scss';
import { myUserQuery } from '@/graphql/query/my/my-section';

export default function MenuPage() {
  const [queryRef, loadUser] = useQueryLoader<mySectionUserQuery>(myUserQuery);
  const { auth } = useAuthContext();

  useEffect(() => {
    if (auth.apiToken) {
      loadUser({});
    }
  }, [auth.apiToken, loadUser]);

  return (
    <AuthGuard>
      <PageViewEventLogger pageName={'more'}>
        <MenuLayerTopNavigation />
        <main className={s.main_content}>
          {queryRef ? (
            <Suspense fallback={<MySectionFallbackComponent />}>
              <MySection queryRef={queryRef} />
            </Suspense>
          ) : (
            <MySectionFallbackComponent />
          )}
          <ul className={'flex flex-col gap-y-tiny-medium pb-spacious-small'}>
            <EventSection />
            <RefundSection />
            <HelpSection />
            <InfoSection />
          </ul>

          {queryRef && <MenuBottomCardBanner queryRef={queryRef} />}
        </main>
      </PageViewEventLogger>
    </AuthGuard>
  );
}
